import React from "react";

const GoToCurrentDayButton = () => {
  const onClick = () => {
    const currentDayElement = document.getElementById("current-day");
    if (currentDayElement) {
      currentDayElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <button
      className="ccw-button ccw-button--primary ccw-shift-log-jump-button"
      onClick={onClick}
      type="button"
    >
      Jump to today
    </button>
  );
};

export default GoToCurrentDayButton;
